import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';

import { AuthProvider } from './../../providers/auth/auth';

import { SettingsPage } from './../settings/settings';

import { IBankDetails } from './../../interfaces/users';

@Component({
  selector: 'page-bank-details',
  templateUrl: 'bank-details.html'
})
export class BankDetailsPage implements OnInit, OnDestroy {
  title = 'Bank Details';
  fbUser: any;
  bankDetails: IBankDetails;
  bankDetailsSubscription: any;
  bankDetailsDataLoaded = false;
  bankDetailsForm: FormGroup;
  bankDetailsFormSubmitted = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    private formBuilder: FormBuilder,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController
  ) {
    this.bankDetailsForm = this.formBuilder.group({
      bank: [''],
      accountNumber: [''],
      accountType: [''],
      branchCode: ['']
    });
  }

  ngOnInit() {
    let loader = this.loadingCtrl.create({
      content: 'Loading your banking details...'
    });
    loader.present();

    this.authProvider.getFbUser().then(fbUser => {
      console.log(fbUser);
      this.fbUser = fbUser;
      this.bankDetailsSubscription = this.authProvider
        .getUserBankDetails(fbUser.uid)
        .subscribe(
          data => {
            console.log(data);
            this.bankDetails = data;
            this.bankDetailsDataLoaded = true;

            if (data !== undefined) {
              this.setupBankingDetailsForm();
            }

            loader.dismiss();
            return data;
          },
          err => {
            console.log(err);
          }
        );
    });
  }

  ngOnDestroy() {
    if (this.bankDetailsSubscription) {
      this.bankDetailsSubscription.unsubscribe();
    }
  }

  setupBankingDetailsForm() {
    this.bankDetailsForm.patchValue(this.bankDetails);
  }

  updateBankDetails() {
    this.bankDetailsFormSubmitted = true;

    let loader = this.loadingCtrl.create({
      content: 'Saving your bank details...'
    });
    loader.present();

    let uid = this.fbUser.uid;
    console.log(uid);

    let bankDetails: IBankDetails = {
      bank: this.bankDetailsForm.value.bank,
      accountNumber: this.bankDetailsForm.value.accountNumber,
      accountType: this.bankDetailsForm.value.accountType,
      branchCode: this.bankDetailsForm.value.branchCode
    }

    this.authProvider
      .updateUserBankDetails(uid, bankDetails)
      .then(() => {
        console.log('banking details have been updated');
        loader.dismiss();

        let alert = this.alertCtrl.create({
          title: 'Update successful!',
          message: 'Your banking details have been saved.',
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
              handler: () => {
                console.log('Ok clicked');
                this.navCtrl.pop();
              }
            }
          ]
        });
        alert.present();

        this.bankDetailsFormSubmitted = false;
      })
      .catch(err => {
        console.log(err);
      });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BankDetailsPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/bank-details/bank-details.ts